import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";

export const StoriesSection = () => {
  const [stories, setStories] = useState([]);

  useEffect(() => {
    api.get("/stories").then((r) => setStories(r.data)).catch(() => {});
  }, []);

  return (
    <section id="verhalen" data-testid="stories-section" className="py-28 sm:py-36 bg-sand-100/50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="max-w-xl">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
            className="font-sans text-xs font-light tracking-[0.35em] uppercase text-terracotta-500 mb-6"
          >
            02 — Verhalen
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="font-serif text-4xl sm:text-5xl font-light tracking-tight text-sand-900 leading-tight"
          >
            Geschreven <em className="text-terracotta-500">in stilte</em>
          </motion.h2>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 gap-10 sm:gap-14">
          {stories.map((story, i) => (
            <motion.div
              key={story.id}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12 }}
              className={i % 2 === 1 ? "sm:mt-20" : ""}
            >
              <Link
                to={`/verhaal/${story.slug}`}
                data-testid={`story-card-${story.slug}`}
                className="group block"
              >
                <div className="overflow-hidden rounded-sm">
                  <img
                    src="https://images.unsplash.com/photo-1554147090-e1221a04a025"
                    alt=""
                    loading="lazy"
                    className="w-full aspect-[4/3] object-cover contrast-110 saturate-50 transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
                <h3 className="mt-6 font-serif text-3xl font-light tracking-tight text-sand-900 transition-colors duration-300 group-hover:text-terracotta-500">
                  {story.title}
                </h3>
                {story.excerpt && (
                  <p className="mt-3 font-sans text-base font-light leading-relaxed text-sand-900/60">
                    {story.excerpt}
                  </p>
                )}
                <span className="inline-block mt-4 font-sans text-xs font-light tracking-[0.25em] uppercase text-terracotta-500">
                  Lees verder →
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
